import React from "react";
import { Link } from "react-router-dom";
import "./index.scss";
function NotFound() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <h2 className="not-found-title">404 - Page Not Found</h2>
        <p className="not-found-message">
          Oops! The page you are looking for does not exist.
        </p>
        <Link to="/" className="not-found-link">
          Go to Home
        </Link>
      </div>
    </div>
  );
}

export default NotFound;
